interface ArtifactTraceRow {
	path: string;
	traceId?: string | null;
}

export function prioritizeAndLimitArtifactTraceRows<T extends ArtifactTraceRow>(rows: T[], limit: number): T[] {
	return rows
		.slice()
		.sort((left, right) => {
			const leftMapped = left.traceId ? 0 : 1;
			const rightMapped = right.traceId ? 0 : 1;
			if (leftMapped !== rightMapped) {
				return leftMapped - rightMapped;
			}

			return left.path.localeCompare(right.path, undefined, { sensitivity: 'base' });
		})
		.slice(0, limit);
}
